export default __webpack_public_path__ + "static/media/third-visual.98017a0e.png";